import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { BrandedHeader } from '../presentationalComponents/BrandedHeader';

const mapStateToProps = (state: IAppState) => {
  return {
    appName: state.GlobalState.sourceApp || state.GlobalState.appVer,
  };
};

export const BrandedHeaderContainer = connect(
  mapStateToProps
)(BrandedHeader);
